
export const ASYNC_DOMAIN_CHECK = "kopaproLicense/domains/asyncCheck";
export const ASYNC_PURCHASE = "kopaproLicense/domains/asyncPurchase";
export const ASYNC_MAP_KOPAPRO = "kopaproLicense/domains/asyncMapKopapro";

export const REQUEST_SUCCESS = "kopaproLicense/domains/success";
export const REQUEST_FAILURE = "kopaproLicense/domains/failure";

export const initialState = {   
    domains: []
}

export default function reducer(state=initialState ,action){
    switch(action.type){
        
        default:            
        return state;
    }
}

export const asyncCheck = (domain, callback) => ({
    type: ASYNC_DOMAIN_CHECK, payload:{
        domain,
        callback
    }
})


export const asyncPurchase = (body, domain, years, needWHOISPrivacy, paymentMethod, callback) => ({
    type: ASYNC_PURCHASE, payload:{
        body,
        domain,
        years,
        needWHOISPrivacy,
        paymentMethod,
        callback
    }
})


export const asyncMapKopapro = (domainUUID, code, callback) => ({
    type: ASYNC_MAP_KOPAPRO, payload:{
        domainUUID,
        code,
        callback
    }
})



